// AI Generated Component
import { Component, OnInit, OnDestroy, DestroyRef } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { SessionService } from '@monsido/core/session/session.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { Subscription } from 'rxjs';
import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';

@Component({
    selector: 'submenu-policy',
    standalone: false,
    template: `
        <nav [attr.aria-label]="getSubNavigationLabel()" id="submenu" class="navbar navbar-inverse d-none d-sm-block">
            <div class="container-fluid d-flex flex-column align-items-center">
                <ul class="nav d-flex align-items-stretch max-height">
                    <li *ngFor="let link of links; trackBy: trackByIndex"
                        class="d-flex align-items-stretch">
                        <ng-container *ngIf="!link.hasOwnProperty('show') || link.show">
                            <a [uiSref]="link.href"
                               *ngIf="link.href"
                               [attr.data-test]="'sub-menu-item-' + link.name"
                               [attr.aria-label]="link.name"
                               class="d-flex align-items-center px-4"
                               [class.active]="isSubentryActive(link.section)"
                               [ngbTooltip]="link.name"
                               [container]="'body'"
                               triggers="hover"
                               tooltipClass="text-ellipsis enableTooltip"
                               placement="bottom"
                               monEventTrigger="actionTrigger"
                               [monEventParams]="{action: 'navigation-' + link.event + '-btn'}">
                                <span class="fa-lg fa-fw"
                                      *ngIf="link.icon"
                                      aria-hidden="true"
                                      [class]="link.icon">
                                </span>
                                <mon-icon
                                    *ngIf="link.iconDirect"
                                    size="lg"
                                    [monIconDirect]="link.iconDirect"></mon-icon>
                                <div class="notification-circle" *ngIf="link.notification"></div>
                                <span class="ml-1 link-text">
                                    {{ link.name }}
                                    <mon-icon
                                        *ngIf="link.openInNewTab"
                                        class="ml-1"
                                        size="xs"
                                        monIconDirect="faUpRightFromSquare"></mon-icon>
                                </span>
                                <span class="label label-new ml-1 mb-2" *ngIf="link.isBeta" translate>BETA</span>
                                <img class="picture"
                                    *ngIf="link.pic"
                                    [src]="'/images/' + link.pic"
                                    [alt]="link.pictureAlt || ''">
                            </a>
                            <a [href]="link.url"
                               *ngIf="link.url"
                               rel="noopener"
                               target="_blank"
                               aria-describedby="linkOpensInNewTab"
                               monEventTrigger="actionTrigger"
                               placement="bottom"
                               [attr.data-test]="'sub-menu-item-' + link.name"
                               [attr.aria-label]="link.name"
                               triggers="hover"
                               [ngbTooltip]="link.name"
                               [container]="'body'"
                               tooltipClass="text-ellipsis enableTooltip"
                               [monEventParams]="{action: 'navigation-' + link.event + '-btn'}"
                               class="d-flex align-items-center px-4"
                               [class.active]="isSubentryActive(link.section)">
                                <mon-icon *ngIf="link.iconDirect" size="lg" [monIconDirect]="link.iconDirect"></mon-icon>
                                <span class="ml-1 link-text">{{ link.name }}
                                    <mon-icon class="ml-1" size="xs" monIconDirect="faUpRightFromSquare"></mon-icon>
                                </span>
                                <img class="picture" *ngIf="link.pic" [src]="'/images/' + link.pic" [alt]="link.pictureAlt || ''">
                            </a>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </nav>
    `,
})
export class SubmenuPolicyComponent implements OnInit, OnDestroy {
    changedDomainEventId: any;
    links: any[] = [];
    private onDomainChanged$?: Subscription;

    constructor (
        private translateService: TranslateService,
        private stateService: StateService,
        private monEventService: MonEventService,
        private sessionService: SessionService,
        private pipeService: PipeService,
        private coreDomainService: CoreDomainService,
        private destroyRef: DestroyRef,
    ) {}

    ngOnInit (): void {
        this.onDomainChanged$ = this.coreDomainService.onDomainChanged.subscribe(() => this.getLinks());
        this.getLinks();
        this.destroyRef.onDestroy(() => {
            this.onDomainChanged$?.unsubscribe();
        });
    }

    ngOnDestroy (): void {
        this.monEventService.remove(this.changedDomainEventId);
    }

    trackByIndex (index: number): number {
        return index;
    }

    getSubNavigationLabel (): string {
        return this.translateService.getString('Sub Navigation');
    }

    isSubentryActive (destination: string): boolean {
        const currentName = this.stateService.current?.name;
        return currentName ? currentName.indexOf(destination) > -1 : false;
    }

    getLinks (): void {
        this.links = [
            {
                notification: false,
                name: this.translateService.getString('Global Policy Dashboard'),
                section: 'base.customer.global.policy.dashboard',
                href: 'base.customer.global.policy.dashboard',
                icon: this.pipeService.get('monIcons')(['MENUES', 'POLICIES']),
                tooltip: this.translateService.getString('Global Policy Dashboard'),
            },
            {
                notification: false,
                name: this.translateService.getString('Policy List'),
                section: 'base.customer.global.policy.policies',
                href: 'base.customer.global.policy.policies',
                icon: this.pipeService.get('monIcons')(['POLICIES', 'LIST']),
                tooltip: this.translateService.getString('Policy List'),
                event: 'policy-list',
            },
            {
                notification: false,
                name: this.translateService.getString('Policy Assistant'),
                section: 'base.customer.global.policy.bot',
                href: 'base.customer.global.policy.bot',
                icon: this.pipeService.get('monIcons')(['POLICIES', 'SPARKLES']),
                tooltip: this.translateService.getString('Policy Assistant'),
                event: 'policy-list',
                show: this.sessionService.customer?.plan_traits?.policy_bot,
            },
        ];
    }
}
